export enum AutomationServicesCodeEnum {
  FMC = 'FMC',
  PYC = 'PYC',
}
